import { render, staticRenderFns } from "./TablePagination.ts.vue?vue&type=template&id=672c2c14"
import script from "./TablePagination.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./TablePagination.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TablePagination.ts.vue?vue&type=style&index=0&id=672c2c14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports